// extracted by css-extract-rspack-plugin
export default {"wrapperChart":"cY8FN_jL0sTyiedR","noData":"Qxi_Aokj_yIDo1wO","back":"SAWzedupQsIuFWUZ","marginTop":"KS82nVgmFO863d8s"};